import { FAST_INVOICE_MAKER, FOLLLOWUPS_MEETS, INSTANT_VENUE_CHECKER, STATUS_COMPLETED, STATUS_INPROGRESS, STATUS_PENDING, TAG_CUSTOMER_INTEREST, TEAM_ROLES_SETUP, VENDOR_HUB, VISITOR_LOG_BOOK } from "./VMConstants";
import { VM_Colors } from "../Styles/VMStyles";
import { toTitleCase } from "./UtilHelper";


export const world_phoneCodes =  [
  { "country": "Afghanistan", "code": "+93" },
  { "country": "Albania", "code": "+355" },
  { "country": "Algeria", "code": "+213" },
  { "country": "Andorra", "code": "+376" },
  { "country": "Angola", "code": "+244" },
  { "country": "Antigua and Barbuda", "code": "+1-268" },
  { "country": "Argentina", "code": "+54" },
  { "country": "Armenia", "code": "+374" },
  { "country": "Australia", "code": "+61" },
  { "country": "Austria", "code": "+43" },
  { "country": "Azerbaijan", "code": "+994" },

  { "country": "Bahamas", "code": "+1-242" },
  { "country": "Bahrain", "code": "+973" },
  { "country": "Bangladesh", "code": "+880" },
  { "country": "Barbados", "code": "+1-246" },
  { "country": "Belarus", "code": "+375" },
  { "country": "Belgium", "code": "+32" },
  { "country": "Belize", "code": "+501" },
  { "country": "Benin", "code": "+229" },
  { "country": "Bhutan", "code": "+975" },
  { "country": "Bolivia", "code": "+591" },
  { "country": "Bosnia and Herzegovina", "code": "+387" },
  { "country": "Botswana", "code": "+267" },
  { "country": "Brazil", "code": "+55" },
  { "country": "Brunei", "code": "+673" },
  { "country": "Bulgaria", "code": "+359" },
  { "country": "Burkina Faso", "code": "+226" },
  { "country": "Burundi", "code": "+257" },

  { "country": "Cabo Verde", "code": "+238" },
  { "country": "Cambodia", "code": "+855" },
  { "country": "Cameroon", "code": "+237" },
  { "country": "Canada", "code": "+1" },
  { "country": "Central African Republic", "code": "+236" },
  { "country": "Chad", "code": "+235" },
  { "country": "Chile", "code": "+56" },
  { "country": "China", "code": "+86" },
  { "country": "Colombia", "code": "+57" },
  { "country": "Comoros", "code": "+269" },
  { "country": "Congo (Republic)", "code": "+242" },
  { "country": "Congo (DRC)", "code": "+243" },
  { "country": "Costa Rica", "code": "+506" },
  { "country": "Croatia", "code": "+385" },
  { "country": "Cuba", "code": "+53" },
  { "country": "Cyprus", "code": "+357" },
  { "country": "Czech Republic", "code": "+420" },

  { "country": "Denmark", "code": "+45" },
  { "country": "Djibouti", "code": "+253" },
  { "country": "Dominica", "code": "+1-767" },
  { "country": "Dominican Republic", "code": "+1-809,+1-829,+1-849" },

  { "country": "Ecuador", "code": "+593" },
  { "country": "Egypt", "code": "+20" },
  { "country": "El Salvador", "code": "+503" },
  { "country": "Equatorial Guinea", "code": "+240" },
  { "country": "Eritrea", "code": "+291" },
  { "country": "Estonia", "code": "+372" },
  { "country": "Eswatini", "code": "+268" },
  { "country": "Ethiopia", "code": "+251" },

  { "country": "Fiji", "code": "+679" },
  { "country": "Finland", "code": "+358" },
  { "country": "France", "code": "+33" },

  { "country": "Gabon", "code": "+241" },
  { "country": "Gambia", "code": "+220" },
  { "country": "Georgia", "code": "+995" },
  { "country": "Germany", "code": "+49" },
  { "country": "Ghana", "code": "+233" },
  { "country": "Greece", "code": "+30" },
  { "country": "Grenada", "code": "+1-473" },
  { "country": "Guatemala", "code": "+502" },
  { "country": "Guinea", "code": "+224" },
  { "country": "Guinea-Bissau", "code": "+245" },
  { "country": "Guyana", "code": "+592" },

  { "country": "Haiti", "code": "+509" },
  { "country": "Honduras", "code": "+504" },
  { "country": "Hong Kong", "code": "+852" },
  { "country": "Hungary", "code": "+36" },

  { "country": "Iceland", "code": "+354" },
  { "country": "India", "code": "+91" },
  { "country": "Indonesia", "code": "+62" },
  { "country": "Iran", "code": "+98" },
  { "country": "Iraq", "code": "+964" },
  { "country": "Ireland", "code": "+353" },
  { "country": "Israel", "code": "+972" },
  { "country": "Italy", "code": "+39" },

  { "country": "Jamaica", "code": "+1-876" },
  { "country": "Japan", "code": "+81" },
  { "country": "Jordan", "code": "+962" },

  { "country": "Kazakhstan", "code": "+7" },
  { "country": "Kenya", "code": "+254" },
  { "country": "Kiribati", "code": "+686" },
  { "country": "Korea (North)", "code": "+850" },
  { "country": "Korea (South)", "code": "+82" },
  { "country": "Kuwait", "code": "+965" },
  { "country": "Kyrgyzstan", "code": "+996" },

  { "country": "Laos", "code": "+856" },
  { "country": "Latvia", "code": "+371" },
  { "country": "Lebanon", "code": "+961" },
  { "country": "Lesotho", "code": "+266" },
  { "country": "Liberia", "code": "+231" },
  { "country": "Libya", "code": "+218" },
  { "country": "Liechtenstein", "code": "+423" },
  { "country": "Lithuania", "code": "+370" },
  { "country": "Luxembourg", "code": "+352" },

  { "country": "Macau", "code": "+853" },
  { "country": "Madagascar", "code": "+261" },
  { "country": "Malawi", "code": "+265" },
  { "country": "Malaysia", "code": "+60" },
  { "country": "Maldives", "code": "+960" },
  { "country": "Mali", "code": "+223" },
  { "country": "Malta", "code": "+356" },
  { "country": "Marshall Islands", "code": "+692" },
  { "country": "Mauritania", "code": "+222" },
  { "country": "Mauritius", "code": "+230" },
  { "country": "Mexico", "code": "+52" },
  { "country": "Micronesia", "code": "+691" },
  { "country": "Moldova", "code": "+373" },
  { "country": "Monaco", "code": "+377" },
  { "country": "Mongolia", "code": "+976" },
  { "country": "Montenegro", "code": "+382" },
  { "country": "Morocco", "code": "+212" },
  { "country": "Mozambique", "code": "+258" },
  { "country": "Myanmar", "code": "+95" },

  { "country": "Namibia", "code": "+264" },
  { "country": "Nauru", "code": "+674" },
  { "country": "Nepal", "code": "+977" },
  { "country": "Netherlands", "code": "+31" },
  { "country": "New Zealand", "code": "+64" },
  { "country": "Nicaragua", "code": "+505" },
  { "country": "Niger", "code": "+227" },
  { "country": "Nigeria", "code": "+234" },
  { "country": "North Macedonia", "code": "+389" },
  { "country": "Norway", "code": "+47" },

  { "country": "Oman", "code": "+968" },

  { "country": "Pakistan", "code": "+92" },
  { "country": "Palau", "code": "+680" },
  { "country": "Panama", "code": "+507" },
  { "country": "Papua New Guinea", "code": "+675" },
  { "country": "Paraguay", "code": "+595" },
  { "country": "Peru", "code": "+51" },
  { "country": "Philippines", "code": "+63" },
  { "country": "Poland", "code": "+48" },
  { "country": "Portugal", "code": "+351" },
  { "country": "Puerto Rico", "code": "+1-787,+1-939" },

  { "country": "Qatar", "code": "+974" },

  { "country": "Romania", "code": "+40" },
  { "country": "Russia", "code": "+7" },
  { "country": "Rwanda", "code": "+250" },

  { "country": "Saint Kitts and Nevis", "code": "+1-869" },
  { "country": "Saint Lucia", "code": "+1-758" },
  { "country": "Saint Vincent and the Grenadines", "code": "+1-784" },
  { "country": "Samoa", "code": "+685" },
  { "country": "San Marino", "code": "+378" },
  { "country": "Sao Tome and Principe", "code": "+239" },
  { "country": "Saudi Arabia", "code": "+966" },
  { "country": "Senegal", "code": "+221" },
  { "country": "Serbia", "code": "+381" },
  { "country": "Seychelles", "code": "+248" },
  { "country": "Sierra Leone", "code": "+232" },
  { "country": "Singapore", "code": "+65" },
  { "country": "Slovakia", "code": "+421" },
  { "country": "Slovenia", "code": "+386" },
  { "country": "Solomon Islands", "code": "+677" },
  { "country": "Somalia", "code": "+252" },
  { "country": "South Africa", "code": "+27" },
  { "country": "South Sudan", "code": "+211" },
  { "country": "Spain", "code": "+34" },
  { "country": "Sri Lanka", "code": "+94" },
  { "country": "Sudan", "code": "+249" },
  { "country": "Suriname", "code": "+597" },
  { "country": "Sweden", "code": "+46" },
  { "country": "Switzerland", "code": "+41" },
  { "country": "Syria", "code": "+963" },

  { "country": "Taiwan", "code": "+886" },
  { "country": "Tajikistan", "code": "+992" },
  { "country": "Tanzania", "code": "+255" },
  { "country": "Thailand", "code": "+66" },
  { "country": "Togo", "code": "+228" },
  { "country": "Tonga", "code": "+676" },
  { "country": "Trinidad and Tobago", "code": "+1-868" },
  { "country": "Tunisia", "code": "+216" },
  { "country": "Turkey", "code": "+90" },
  { "country": "Turkmenistan", "code": "+993" },
  { "country": "Tuvalu", "code": "+688" },

  { "country": "Uganda", "code": "+256" },
  { "country": "Ukraine", "code": "+380" },
  { "country": "United Arab Emirates", "code": "+971" },
  { "country": "United Kingdom", "code": "+44" },
  { "country": "United States", "code": "+1" },
  { "country": "Uruguay", "code": "+598" },
  { "country": "Uzbekistan", "code": "+998" },

  { "country": "Vanuatu", "code": "+678" },
  { "country": "Vatican City", "code": "+379" },
  { "country": "Venezuela", "code": "+58" },
  { "country": "Vietnam", "code": "+84" },

  { "country": "Yemen", "code": "+967" },

  { "country": "Zambia", "code": "+260" },
  { "country": "Zimbabwe", "code": "+263" }
]



export const Login_Grid_Items =  [
  { img: '/static/venue.svg', desc: INSTANT_VENUE_CHECKER },
  { img: '/static/user-star.svg', desc: TAG_CUSTOMER_INTEREST },
  { img: '/static/team-plus.svg', desc: TEAM_ROLES_SETUP },
  { img: '/static/invoice.svg', desc: FAST_INVOICE_MAKER },
  { img: '/static/user-up.svg', desc: FOLLLOWUPS_MEETS },
  { img: '/static/topology-star.svg', desc: VENDOR_HUB },
  { img: '/static/address-book.svg', desc: VISITOR_LOG_BOOK },
];

export const roomTypeOptions = [
  "Single Room", 
  "Double Room", 
  "Deluxe Room", 
  "Executive Room", 
  "Suit Room", 
  // "Others",
];


export const taskStatusConfig = [
  {
    title: 'Total Tasks',
    icon: '/static/total_tasks.svg',//<BarChartIcon fontSize="small" />,
    borderColor: 'primary.main',
    gradientFrom: 'primary.light',
    textColor: 'text.primary',
    subtitle: 'Active projects',
    statKey: 'total',
  },
  {
    title: STATUS_PENDING,
    icon: '/static/total_pending.svg',//<ErrorOutlineIcon fontSize="small" />,
    borderColor: VM_Colors.error,//'error.main',
    gradientFrom: VM_Colors.error,// 'error.light',
    textColor: 'error.main',
    subtitle: 'Needs attention',
    statKey: 'pending',
  },
   {
    title: STATUS_INPROGRESS,
    icon: '/static/total_inprogress.svg',//<AccessTimeIcon fontSize="small" />,
    borderColor: 'warning.main',
    gradientFrom: 'warning.light',
    textColor: 'warning.main',
    subtitle: 'Currently active',
    statKey: 'inProgress',
  },
  {
    title: STATUS_COMPLETED,
    icon: '/static/total_completed.svg',//<CheckCircleIcon fontSize="small" />,
    borderColor: 'success.main',
    gradientFrom: 'success.light',
    textColor: 'success.main',
    subtitle: 'completionRate',
    statKey: 'completed',
  },
  
];


export const checkListStatusConfig = [
  {
    title: 'Total CheckLists',
    icon: '/static/total_tasks.svg',//<BarChartIcon fontSize="small" />,
    borderColor: 'primary.main',
    gradientFrom: 'primary.light',
    textColor: 'text.primary',
    subtitle: 'Active projects',
    statKey: 'total',
  },
  {
    title: STATUS_PENDING,
    icon: '/static/total_pending.svg',//<ErrorOutlineIcon fontSize="small" />,
    borderColor: VM_Colors.error,//'error.main',
    gradientFrom: VM_Colors.error,// 'error.light',
    textColor: 'error.main',
    subtitle: 'Needs attention',
    statKey: 'pending',
  },
   {
    title: STATUS_INPROGRESS,
    icon: '/static/total_inprogress.svg',//<AccessTimeIcon fontSize="small" />,
    borderColor: 'warning.main',
    gradientFrom: 'warning.light',
    textColor: 'warning.main',
    subtitle: 'Currently active',
    statKey: 'inProgress',
  },
  {
    title: STATUS_COMPLETED,
    icon: '/static/total_completed.svg',//<CheckCircleIcon fontSize="small" />,
    borderColor: 'success.main',
    gradientFrom: 'success.light',
    textColor: 'success.main',
    subtitle: 'completionRate',
    statKey: 'completed',
  },
  
];


 export const getPriorityColor = (priority) => {
    switch (priority) {
      case 'High':
        return 'error';
      case 'Medium':
        return 'warning';
      case 'Low':
        return 'info';
      default:
        return 'default';
    }
  };

  export const formatDate = (dateString) =>
      new Date(dateString).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
  
 export const roleOptions = ['Admin', 'Manager', 'Executive'];     


export const landing_features = [
  {
    icon: "/static/venue_availability_check.jpg",
    title: toTitleCase("Venue Availability Check"),
    description:toTitleCase(`Whether You Have Single Hall or Lawn At Your Venue (OR) Multiple Halls & Lawns at Your Venue ! You Can Check Their Availability By Single Click On Calander.`),
    iconColor: "bg-feature-blue",
  },
  {
    icon: '/static/enquiry_management.jpg',
    title: toTitleCase("Enquiry Management"),
    description:toTitleCase(`Capture customer enquiries, categorize them as Leads, Customers, or Not Interested, and never miss a potential booking.`),
    iconColor: "bg-feature-green",
  },
  {
    icon: "/static/followup_appointments.jpg",
    title: toTitleCase("Follow-up's & Appointments"),
    description:toTitleCase(`Set reminders, schedule follow-ups, and manage appointments — stay connected with your clients at every step.`),
    gradient: "bg-gradient-to-br from-blue-50 to-blue-100",
    iconColor: "bg-feature-blue",
  },
  {
    icon: '/static/event_vendor_coordination.jpg',
    title: toTitleCase("Event Vendor Co-ordination"),
    description:toTitleCase(`Add and manage Event vendor contacts like caterers, decorators, and event planners and can easily co-ordinate by click on Call, SMS, WhatsApp and Email buttons.`),
    gradient: "bg-gradient-to-br from-teal-50 to-teal-100",
    iconColor: "bg-feature-teal",
  },
  {
    icon: "static/invoice_generation.jpg",
    title: toTitleCase("Invoice Generation"),
    description:toTitleCase(`Create professional invoices by choosing different Templates in just a few clicks where you can update and share and Download them with clients Instantly.`),
    gradient: "bg-gradient-to-br from-orange-50 to-orange-100",
    iconColor: "bg-feature-orange",
  },
  {
    icon: "/static/payments_remainders.jpg",
    title: toTitleCase("Payment Reminders"),
    description:toTitleCase(`Monitor your  payments by scheduling remainders as Notifications. `),
    gradient: "bg-gradient-to-br from-green-50 to-green-100",
    iconColor: "bg-feature-green",
  },
  {
    icon: '/static/team_role_management.jpg',
    title: toTitleCase("Team & Role Management"),
    description:
      toTitleCase("Add staff and assign roles like Admin, Manager, Executive, Receptionist, Security with custom access control."),
  },
  {
    icon: '/static/visitor_management.jpg',
    title: toTitleCase("Visitors Log"),
    description:toTitleCase(`Maintain a smart visitor log that records visitors entries by day, week, month, or year. No more paper logs!`),
    gradient: "bg-gradient-to-br from-purple-50 to-purple-100",
    iconColor: "bg-feature-purple",
  },
  {
    icon: '/static/task_management.jpg',
    title: toTitleCase("Task Management"),
    description:toTitleCase(`Assign Event tasks to your team, set priorities, and track progress for better accountability and efficiency.`),
    gradient: "bg-gradient-to-br from-purple-50 to-purple-100",
    iconColor: "bg-feature-purple",
  },
  {
    icon: '/static/checklist_management.jpg',
    title: toTitleCase("Checklist Management"),
    description:toTitleCase(`Create checklists for each event and assign them to your team to ensure smooth execution and attention to detail.`),
    gradient: "bg-gradient-to-br from-orange-50 to-orange-100",
    iconColor: "bg-feature-orange",
  },
  {
    icon: '/static/feedback_management.jpg',
    title: toTitleCase("Feedback Management"),
    description: toTitleCase(`Feedback management helps venues collect, track, and act on client and guest feedback to continuously improve service quality, event execution, and overall venue experience.`),
    gradient: "bg-gradient-to-br from-pink-50 to-pink-100",
    iconColor: "bg-feature-pink",
  },
  {
    icon: '/static/revenue_checker.jpg',
    title: toTitleCase("Revenue Checker"),
    description: toTitleCase(`A smart revenue checker that gives venue managers real-time visibility into  payments, and overall venue revenue.`),
    gradient: "bg-gradient-to-br from-teal-50 to-teal-100",
    iconColor: "bg-feature-teal",
  },
];


 export const landing_venueData = [
    {
      id: '01',
      title: 'CONVENTION & FUNCTION HALLS',
      image: "/static/convention_hall.jpg",
      description:
        toTitleCase('Convention and function halls are built for large-scale events and can accommodate thousands of guests. These venues often include multiple halls or spaces under one roof. With Venue Manager CRM, you can register each hall or lawn as a sub-venue, allowing banquet sales teams to manage bookings and availability effortlessly — all in one system.')
    },
    {
      id: '02',
      title: 'BANQUET HALLS',
      image: '/static/banquet_hall.jpg',
      description:
        toTitleCase('Ideal for small to mid-sized gatherings, banquet halls are commonly found in hotels and event centers. With multiple halls catering to different event sizes, our Venue manager crm app is designed to manage them all efficiently — ensuring accurate scheduling, enquiry tracking, and smooth coordination.')
    },
    {
      id: '03',
      title: 'RESORTS',
      image:"/static/resorts.jpg",
      description:
        toTitleCase('Resorts have become top choices for destination-style events, especially when guests are traveling from out of town. Resorts typically offer a mix of sub-venues such as open lawns, banquet halls, and private areas. Venue Manager enables easy management of all these spaces — from enquiry to execution.')
    },
    {
      id: '04',
      title: 'FARM HOUSES',
      image:'/static/farm_house.jpg',
      description:
        toTitleCase('Farmhouses are popular event spots in major cities, especially for family gatherings, private parties, and casual corporate events & Other Events. Venue Manager offers a dedicated “Rent-Only” option, making it ideal for venues that provide space without in-house services.')
    },
    {
      id: '05',
      title: 'CLUB HOUSES',
      image:'/static/club_house.jpg',
      description:
        toTitleCase('Often located within apartment communities or gated layouts, clubhouses offer well-maintained event spaces for small-scale events like birthdays, meetings, or get-togethers. Venue Manager helps manage bookings, visitor logs, and team roles seamlessly — even in community-run spaces.')
    },
    {
      id: '06',
      title: 'VILLAS',
      image: '/static/villas.jpeg',
      description:
        toTitleCase(`Villas are small event spaces ideal for intimate gatherings, private parties, birthdays, family celebrations and small weddings. Managing enquiries, bookings, guest details and payments can become challenging when handled manually. Venue Manager CRM helps villa rental owners manage the complete booking process from one platform. Track enquiries, check availability, manage bookings, generate invoices, monitor payments and coordinate your team efficiently. Create tasks and checklists to prepare the villa before guest arrival and maintain better customer experiences.`)
    },
    {
      id: '07',
      title: 'OTHER EVENT VENUES',
      image: '/static/other_events.jpg',
      description:
        toTitleCase(`From exhibition halls, wedding lawns, Cultural Centers & Auditoriums, Private Villas / Bungalows for Events  to corporate event centers and popup venues — Venue Manager adapts to your space. Whether it's a temporary setup or a multi-purpose venue, you can register it, manage bookings, assign teams, and track performance with ease.`)
    }
  ];

